import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { loadFont, optimizeScroll, debounce } from './utils/performance';

// Performance optimizations on page load
if (typeof window !== 'undefined') {
  // Load font asynchronously when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      loadFont('Poppins', 'https://fonts.googleapis.com/css2?family=Poppins:wght@400;600&display=swap');
    });
  } else {
    loadFont('Poppins', 'https://fonts.googleapis.com/css2?family=Poppins:wght@400;600&display=swap');
  }

  // Optimize scroll performance
  const optimizedScrollHandler = optimizeScroll(() => {
    // Handle scroll events here if needed
  });
  window.addEventListener('scroll', optimizedScrollHandler, { passive: true });

  // Debounce resize events
  const debouncedResize = debounce(() => {
    // Handle resize events here if needed
  }, 250);
  window.addEventListener('resize', debouncedResize, { passive: true });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Report Web Vitals for performance monitoring
// Target metrics:
// - LCP (Largest Contentful Paint) < 2.5s
// - FID (First Input Delay) < 100ms
// - CLS (Cumulative Layout Shift) < 0.1
reportWebVitals((metric) => {
  // Log to console in development
  if (process.env.NODE_ENV === 'development') {
    console.log(metric);
  }

  // Send to analytics in production
  if (process.env.NODE_ENV === 'production') {
    // Example: Send to Google Analytics or your analytics service
    if (typeof window !== 'undefined' && window.gtag) {
      window.gtag('event', metric.name, {
        event_category: 'Web Vitals',
        value: Math.round(metric.name === 'CLS' ? metric.value * 1000 : metric.value),
        event_label: metric.id,
        non_interaction: true,
      });
    }
  }
});
